import UiStore from './ui/ui-store';
import DataStore from './data/data-store';

interface IRootStore {
  uiStore: UiStore;
  dataStore: DataStore;
}
class RootStore implements IRootStore {
  uiStore: UiStore = {} as UiStore;
  dataStore: DataStore = {} as DataStore;

  // Used by mobx-easy
  init() {
    this.uiStore = new UiStore();
    this.dataStore = new DataStore();
  }
}

export default RootStore;
